import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { publicRouteGuard } from '@/utils/routeGuards'
import LoginPage from '@/features/Auth/pages/Login'

const loginSearchSchema = z.object({
  error: z.string().optional(),
})

export const Route = createFileRoute('/auth/login')({
  validateSearch: loginSearchSchema,
  beforeLoad: publicRouteGuard,
  component: LoginPage,
})
